type TranslationContent = {
  consent: string;
  mandatoryInfo: string;
  labelTopic: string;
  labelProduct: string;
  labelDescription: string;
  labelLot: string;
  labelCode: string;
  labelSalutation: string;
  labelFirstname: string;
  labelLastname: string;
  labelStreet: string;
  labelZip: string;
  labelCity: string;
  labelState: string;
  labelEmail: string;
  labelPhone: string;
  labelSubmit: string;
  labelInitialStateOption: string;
  labelInitialTopicOption: string;
  labelInitialSalutationOption: string;
  successMsg: string;
  errorMsg: string;
};

type Translations = Record<string, TranslationContent>;

export const translationConfig: Translations = {
  de_DE: {
    consent:
      'Deine Daten werden von uns ausschließlich zur Durchführung dieser Aktion genutzt. Es erfolgt keine weitere Nutzung durch uns oder Dritte. *',
    mandatoryInfo: '* Pflichtangabe',
    labelTopic: 'Thema',
    labelProduct: 'Produktname',
    labelDescription: 'Was können wir für dich tun?',
    labelLot: 'Chargennummer',
    labelCode: 'Barcode',
    labelSalutation: 'Anrede',
    labelFirstname: 'Vorname*',
    labelLastname: 'Nachname*',
    labelStreet: 'Straße + Hausnummer',
    labelZip: 'Postleitzahl',
    labelCity: 'Ort',
    labelState: 'Bundesland',
    labelEmail: 'Email*',
    labelPhone: 'Telefone',
    labelSubmit: 'Absenden',
    labelInitialStateOption: 'Bundesland wählen',
    labelInitialTopicOption: 'Thema wählen',
    labelInitialSalutationOption: 'Anrede wählen',
    successMsg: 'Die Nachricht wurde erfolgreich gesendet.',
    errorMsg: 'Die Nachricht konnte nicht gesendet werden, versuchen Sie es später noch einmal.',
  },
  en_US: {
    consent:
      'Your data will be used by us exclusively to perform this action. No further use by us or third parties will occur. *',
    mandatoryInfo: '* Required field',
    labelTopic: 'Subject',
    labelProduct: 'Product Name',
    labelDescription: 'How can we help you?',
    labelLot: 'Batch Number',
    labelCode: 'Barcode',
    labelSalutation: 'Title',
    labelFirstname: 'First Name*',
    labelLastname: 'Last Name*',
    labelStreet: 'Street + House Number',
    labelZip: 'Zip Code',
    labelCity: 'City',
    labelState: 'State',
    labelEmail: 'Email*',
    labelPhone: 'Phone Number',
    labelSubmit: 'Submit',
    labelInitialStateOption: 'Choose state',
    labelInitialTopicOption: 'Choose a topic',
    labelInitialSalutationOption: 'Choose a salutation',
    successMsg: 'Your message was sent successfully.',
    errorMsg: 'Your message could not be sent, please try again later.',
  },
  en_CA: {
    consent:
      'Your data will be used by us exclusively to perform this action. No further use by us or third parties will occur. *',
    mandatoryInfo: '* Required field',
    labelTopic: 'Subject',
    labelProduct: 'Product Name',
    labelDescription: 'How can we help you?',
    labelLot: 'Batch Number',
    labelCode: 'Barcode',
    labelSalutation: 'Title',
    labelFirstname: 'First Name*',
    labelLastname: 'Last Name*',
    labelStreet: 'Street + House Number',
    labelZip: 'Postal Code',
    labelCity: 'City',
    labelState: 'Province',
    labelEmail: 'Email*',
    labelPhone: 'Phone Number',
    labelSubmit: 'Submit',
    labelInitialStateOption: 'Choose province',
    labelInitialTopicOption: 'Choose a topic',
    labelInitialSalutationOption: 'Choose a salutation',
    successMsg: 'Your message was sent successfully.',
    errorMsg: 'Your message could not be sent, please try again later.',
  },
  fr_CA: {
    consent:
      "Vos données seront utilisées par nous exclusivement pour effectuer cette action. Aucune autre utilisation par nous ou des tiers n'est prévue. *",
    mandatoryInfo: '* Champ obligatoire',
    labelTopic: 'Sujet',
    labelProduct: 'Nom du produit',
    labelDescription: 'Comment pouvons-nous vous aider ?',
    labelLot: 'Numéro de lot',
    labelCode: 'Code-barres',
    labelSalutation: 'Civilité',
    labelFirstname: 'Prénom*',
    labelLastname: 'Nom*',
    labelStreet: 'Rue + Numéro de maison',
    labelZip: 'Code postal',
    labelCity: 'Ville',
    labelState: 'Province',
    labelEmail: 'Courriel*',
    labelPhone: 'Téléphone',
    labelSubmit: 'Envoyer',
    labelInitialStateOption: 'Choisissez une province',
    labelInitialTopicOption: 'Choisissez un sujet',
    labelInitialSalutationOption: 'Choisissez une formule de salutation',
    successMsg: 'Votre message a été envoyé avec succès.',
    errorMsg: "Le message n'a pas pu être envoyé, veuillez réessayer plus tard.",
  },
};
